import apiClient from './base.api'
const BASE_ENDPOINT = window.config.USER_BASE_ENDPOINT

export const loginApi = async(username, password) => {
  const payload = {
    username,
    password
  }

  const response = await apiClient.post(`${BASE_ENDPOINT}login/`, payload)

  return response
}

export const logoutAsync = async(payload) => {
  const response = await apiClient.post(`${BASE_ENDPOINT}logout/`, payload)

  return response
}

export const refreshTokenAsync = async(payload) => {
  const response = await apiClient.post(`${BASE_ENDPOINT}login/refresh/`, payload)

  return response
}

export const registerApi = async(username, password, firstName, lastName, phoneNumber, email) => {
  const payload = {
    username,
    password,
    first_name: firstName,
    last_name: lastName,
    phone_number: phoneNumber,
    email
  }

  const response = await apiClient.post(`${BASE_ENDPOINT}register/`, payload)

  return response
}

export const fetchUserDataApi = async() => {
  const response = await apiClient.get(`${BASE_ENDPOINT}user/`)

  return response
}

export const sendPasswordResetAsync = async(email) => {
  const payload = {
    email
  }

  const response = await apiClient.post(`${BASE_ENDPOINT}password-reset/`, payload)

  return response
}

export const sendValidationEmailAsync = async(email) => {
  const payload = {
    email
  }
  const response = await apiClient.post(`${BASE_ENDPOINT}send-validation-email/`, payload)

  return response
}

export const resetPasswordAsync = async(token, newPassword) => {
  const payload = {
    token,
    password: newPassword
  }

  const response = await apiClient.post(`${BASE_ENDPOINT}password-reset/confirm/`, payload)

  return response
}

export const validateEmailAsync = async(token, userId) => {
  const payload = {
    token,
    user_id: userId
  }

  const response = await apiClient.post(`${BASE_ENDPOINT}validate-email/`, payload)

  return response
}

export const sendTokenAsync = async(username) => {
  const payload = {
    username
  }

  const response = await apiClient.post(`${BASE_ENDPOINT}password-reset/from-username/`, payload)

  return response
}

export const updateUserDataApi = async(accessToken, newUserData) => {
  const response = await apiClient.put(`${BASE_ENDPOINT}user/`, newUserData)

  return response
}

export const deleteAccountAsync = async() => {
  const response = await apiClient.delete(`${BASE_ENDPOINT}delete-account/`)

  return response
}

export const fetchUserLimitsAsync = async() => {
  const response = await apiClient.get(`${BASE_ENDPOINT}limits/`)

  return response
}

export const fetchUserContactsAsync = async() => {
  const response = await apiClient.get(`${BASE_ENDPOINT}phonebook/`)

  return response
}

export const createContactAsync = async(payload) => {
  const response = await apiClient.post(`${BASE_ENDPOINT}phonebook/`, payload)

  return response
}

export const updateContactAsync = async(contactId, payload) => {
  const response = await apiClient.put(`${BASE_ENDPOINT}phonebook/${contactId}/`, payload)

  return response
}

export const getContactDetailAsync = async(contactId) => {
  const response = await apiClient.get(`${BASE_ENDPOINT}phonebook/${contactId}/`)

  return response
}

export const deleteContactAsync = async(contactId) => {
  const response = await apiClient.delete(`${BASE_ENDPOINT}phonebook/${contactId}/`)

  return response
}
